module.exports = __webpack_public_path__ + "media/packs/images/flags/IE-d16698b84ed9f443c2e458f533853a50.png";